import RenderHTML from '../../../../../../components/ui-components/RenderHTML'

export function AllocationFundCardTrailingLayout({
  primaryLabel,
  secondaryIconHtml,
  secondaryIconClassName,
  secondaryText
}: {
  primaryLabel: string
  secondaryIconHtml?: string
  secondaryIconClassName?: string
  secondaryText?: string
}) {
  const hasSecondary = Boolean(secondaryText && secondaryText.length > 0)

  if (!hasSecondary) {
    return (
      <div className="shrink-0 text-[14px] font-[500] leading-[150%] text-[#232323] whitespace-nowrap">
        {primaryLabel}
      </div>
    )
  }

  return (
    <div className="flex shrink-0 flex-col items-end gap-0">
      <div className="text-[14px] font-[500] leading-[150%] text-[#232323] whitespace-nowrap">
        {primaryLabel}
      </div>
      <div className="flex items-center justify-end gap-1 py-1 pl-1.5">
        {secondaryIconHtml ? (
          <RenderHTML
            innerHTMLText={secondaryIconHtml}
            className={`size-3 shrink-0 overflow-hidden ${secondaryIconClassName ?? ''}`}
          />
        ) : null}
        <div className="text-[13px] font-[400] leading-[140%] text-[#3D3D3D] whitespace-nowrap">
          {secondaryText}
        </div>
      </div>
    </div>
  )
}
